module.exports = __webpack_public_path__ + "static/media/iphone_14_deep_purple_pro_max.6a1dbb2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_14_deep_purple_pro_max.jpg
// module id = 2132
// module chunks = 0